import { TMetaPrimitives } from '@cian/logger/shared';
import {
  fetchUpdateProject,
  TUpdateProjectRequest,
  TUpdateProjectResponse,
} from 'shared/repositories/promotions-flow-control/v1/update-project';

import { IApplicationContext } from 'shared/types/applicationContext';

export type { TUpdateProjectRequest };

export async function updateProject(
  { logger, httpApi }: IApplicationContext,
  parameters: TUpdateProjectRequest,
): Promise<boolean> {
  try {
    const result: TUpdateProjectResponse = await fetchUpdateProject({ httpApi, parameters });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/updateProject.ts [updateProject]',
        message: 'Не удалось обновить проект',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/updateProject.ts [updateProject]',
      message: 'Не удалось обновить проект',
    });

    throw error;
  }
}
